export const updatePropertyRecipe =
  <T, K extends keyof T>(key: K, data: T[K]) =>
  (draft: T): T => {
    draft[key] = data;
    return draft;
  };
